import { getFetch } from '../fetch';
import { apiConfig } from '../config';

interface DiagnosticByDateRequest {
    courseId: number,
    date: string,
    grade: number,
    subject: string,
}

export type DiagnosticByDateResponse = {
    id: string,
    problemsInfo: {
        lessonName: string,
        lessonMeta: string,
        problems: [
            {
                id: number,
            }
        ]
    },
    courseLessonLinkId: number | null, // находим по связи диагностического занятия с уже выданными уроками
};

export function getDiagnosticByDate(
    request: DiagnosticByDateRequest
): Promise<DiagnosticByDateResponse> {
    const { apiGetDiagnosticByDate } = apiConfig.getStaticUrls();

    return getFetch(apiGetDiagnosticByDate, request);
}
